<template>

  <v-dialog
    v-model="dialog"
    scrollable
    max-width="900px"
    v-if="dialog"
  >
    <v-card v-if="item">
      <v-card-title>
        View document #{{ item.document_id }}

        <v-spacer />

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">

            <v-icon
              color="green lighten-3"
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
            >mdi-information-outline
            </v-icon>

          </template>

          <span>
            Click open in new window<br />
            Shift+Click open inside popup
          </span>

        </v-tooltip>

        <v-btn
          :disabled="!item.data.path"
          :loading="loading"
          color="success"
          outlined
          @click="viewDocument(item,$event)"
        >
          View document
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>

        <v-simple-table class="mt-1">
          <template v-slot:default>
            <tbody>
              <tr>
                <td width="140" class="pr-0"><b>State:</b></td>
                <td>
                  <v-select
                    v-model="item.status"
                    :items="statusMap"
                    hide-details
                    style="width: 200px;"
                    class="my-0 pt-0"
                  >
                    <template v-slot:item="{ item }">
                      <v-icon :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </template>

                    <template v-slot:selection="{ item }">
                      <v-icon :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </template>
                  </v-select>

                </td>
                <td><b>Type:</b></td>
                <td>
                  <v-select
                    v-model="item.type"
                    :loading="!types.length"
                    :items="types"
                    hide-details
                    style="width: 200px;"
                    class="my-0 pt-0"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td width="140" class="pr-0"><b>Created:</b></td>
                <td>{{ get(item, 'created') }}</td>
                <td><b>Updated:</b></td>
                <td>{{ get(item, 'updated') }} by {{ get(item, 'data.operator_name') }}</td>
              </tr>
              <tr>
                <td width="140" class="pr-0"><b>Comment:</b></td>
                <td colspan="3">
                  <withdraw-comments
                    :value="item.data.comment"
                    :commentsPreset="commentsPreset"
                    :save-icon="false"
                    @input="setDataPropWithCastToString($event, 'comment')"
                  />
                  <!--                  <v-select-->
                  <!--                    v-model="item.data.comment"-->
                  <!--                    :items="commentsOptions"-->
                  <!--                    hide-details-->
                  <!--                    class="my-0 pt-0"-->
                  <!--                  />-->
                </td>
              </tr>
              <tr>
                <td width="140" class="pr-0"><b>Internal Comment:</b></td>
                <td colspan="3">

                  <withdraw-comments
                    :value="item.data.internal_comment"
                    :commentsPreset="internalPreset"
                    :save-icon="false"
                    @input="setDataPropWithCastToString($event, 'internal_comment')"
                  />
                  <!--                  <v-select-->
                  <!--                    v-model="item.data.internal_comment"-->
                  <!--                    :items="internalComment"-->
                  <!--                    hide-details-->
                  <!--                    class="my-0 pt-0"-->
                  <!--                  />-->
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div class="pa-0 text-right documents-img" v-if="image">

          <v-btn
            class="documents-close-img"
            @click="image = null"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>


          <v-row class="documents-rotate-img" justify="center">

            <v-btn
              @click="rotation -= 90"
              icon
            >
              <v-icon>mdi-rotate-left</v-icon>
            </v-btn>
            <v-btn
              @click="rotation += 90"
              icon
            >
              <v-icon>mdi-rotate-right</v-icon>
            </v-btn>

          </v-row>

          <v-img
            :style="`margin-top: 0; transform: rotate(${rotation}deg);`"
            max-width="850px"
            :src="image"
          />
        </div>

      </v-card-text>

      <v-divider />

      <v-card-actions class="px-6">
        <v-btn
          :loading="loading"
          color="warning"
          @click="closeDialog"
        >
          Close
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          :loading="loading"
          color="success"
          @click="$emit('save', item)"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
  .documents-img {
    position: relative;
  }

  .documents-close-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
  }

  .documents-rotate-img {
    position: relative;
    top: 0;
    width: 100%;
    /*right: 0;*/
    z-index: 100;
  }
</style>

<script>

  import WithdrawComments from '@/components/helper/WithdrawComments.vue'
  import { get } from 'lodash'
  import { API } from '@/utils/api'
  import { commentsPreset, internalPreset } from '@/utils/mock'

  export default {
    internalPreset,
    commentsPreset,
    components: { WithdrawComments },
    props: {
      loading: {
        type: Boolean,
        required: true,
      },
      value: {
        type: Boolean,
        required: true,
      },
      item: {
        type: [ Object, Boolean ],
        required: true,
      },
      openImage: {
        type: Function,
        required: true,
      },
      commentsPreset: {
        type: Array,
        required: true
      },
      internalPreset: {
        type: Array,
        required: true
      }
    },
    emits: [ 'input', 'save' ],
    data: () => ({
      rotation: 0,

      image: null,
      types: [],
      statusMap: [
        { text: 'On Review', value: 'on_review', icon: 'mdi-eye' },
        { text: 'Accept', value: 'accept', icon: 'mdi-check-circle', color: 'green' },
        { text: 'Decline', value: 'decline', icon: 'mdi-close-circle', color: 'red' },
        { text: 'New', value: 'new', icon: 'mdi-new-box' },
        { text: 'Deleted', value: 'deleted', icon: 'mdi-delete', color: 'grey' } ]
    }),

    mounted () {
    },

    methods: {
      get,

      viewDocument: async function (item, e) {
        this.rotation = 0
        this.image = await this.openImage(item, !e.shiftKey)
      },

      closeDialog: function () {

        this.$nextTick(function () {
          this.$emit('input', false)
        })
      },
      loadTypes: async function () {
        const result = await API.call('/$v/documents/types.json', {
          account_id: this.item.account_id,
          entity_id: this.item.entity_id
        })
        this.types = result.data
      },

      setDataPropWithCastToString(val, prop) {
        // clearable click returns null
        if (!val) {
          val = ''
        }

        this.item.data[prop] = val
      }
    },

    watch: {
      dialog: function () {
        this.image = null
        this.rotation = 0
      },
      item: {
        handler () {
          this.loadTypes()
        },
        deep: true
      }
    },

    computed: {
      commentsOptions () {
        return [ this.item?.data?.comment, ...this.commentsPreset ]
      },
      internalComment () {
        return [ this.item?.data?.internal_comment, ...this.internalPreset ]
      },
      dialog: {
        set: function (newValue) {
          this.$nextTick(function () {
            this.$emit('input', newValue)
          })
          return newValue
        },
        get: function () {
          return this.value
        }
      },
    }
  }
</script>


